import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-scrollable-drag-drop-tabs',
  templateUrl: './scrollable-drag-drop-tabs.component.html',
  styleUrls: ['./scrollable-drag-drop-tabs.component.scss']
})
export class ScrollableDragDropTabsComponent implements OnInit, OnChanges {

  @Input() openDefaultTabIndex;
  @Input() resetTabs;
  @Input() hideTabs;
  @Input() formSavedStatus;
  @Input() addNewItem;
  @Input() tabs;
  @Input() isActiveFormSaved!: () => boolean;

  selectedIndex: number = 0;
  transformStyle: string = '';
  leftTabIdx: number = 0;
  atStart: boolean = true;
  atEnd: boolean = false;

  @Output() emitSelectedTab = new EventEmitter();
  @Output() emitAddNewTab = new EventEmitter();
  @Output() emitHideTabContent = new EventEmitter();
  @Output() emitReorderedTabs = new EventEmitter(); //for order change

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.transformStyle = `translateX(0px)`; 
  }

  selectTab(index) {
    if (this.formSavedStatus === false) {
      this.notificationService.showNotification("info", "Please save the topic details before proceed.");
      return;
    }

    this.selectedIndex = index;
    this.emitSelectedTab.emit({ tabData: this.tabs[index], tabIndex: this.selectedIndex });
    this.scrollTab(index - this.leftTabIdx - 1);
  }

  selectAndHideOtherTab(index) {
    this.selectedIndex = index;
    this.emitHideTabContent.emit({ tabData: this.tabs[index], tabIndex: this.selectedIndex });
    this.scrollTab(index - this.leftTabIdx - 1);
  }

  scrollTab(x) {
    if ((this.atStart && x < 0) || (this.atEnd && x > 0)) {
      return;
    }
    this.leftTabIdx = this.leftTabIdx + x;
    this.transformStyle = `translateX(${this.leftTabIdx * -140}px)`;
    this.atStart = this.leftTabIdx === 0;
    this.atEnd = this.leftTabIdx === this.tabs.length - 1;
  }

 ngOnChanges(changes) {
    if('tabs' in changes && !changes['tabs'].firstChange) {
      if(('resetTabs' in changes && changes['resetTabs'].currentValue == true)) {
        this.selectTab(-1);
        return;
      }
      else {

        //FOR OPEN SELECTED TAB AFTER TOPIC SAVE
        if(this.openDefaultTabIndex) {
          this.selectTab(this.openDefaultTabIndex);
          return;
        }

        this.selectedIndex = 0;
        this.leftTabIdx = 0;
        this.atStart = true;
        this.atEnd = false;
        this.transformStyle = `translateX(0px)`;
        this.selectTab(this.selectedIndex);
      }
    }
    else {
      if(('hideTabs' in changes && changes['hideTabs'].currentValue == true)) {
        if(this.selectedIndex != -1) {
          this.selectAndHideOtherTab(-1);
          return;
        }
      }
    }
  }
  onAddNewItem() {
    this.emitAddNewTab.emit({ status: true });
    //For active last tab
    let tabLength = this.tabs.length - 1;
    this.selectAndHideOtherTab(tabLength);
    this.selectTab(tabLength);
  }

  drop(event: CdkDragDrop<any[]>) {

     if (!this.isActiveFormSaved()) {
      this.notificationService.showNotification("info", "Please save the topic details before proceed.");
      return;
    }
    
    if (event.previousIndex === event.currentIndex) return;

    const prevSelectedTab = this.tabs[this.selectedIndex]; // store currently selected tab
    moveItemInArray(this.tabs, event.previousIndex, event.currentIndex);

    // preserve selected tab even after reorder
    const newIndex = this.tabs.findIndex(t => t === prevSelectedTab);
    this.selectedIndex = newIndex;

    // emit new order to parent
    this.emitReorderedTabs.emit(this.tabs);
    this.emitSelectedTab.emit({ tabData: this.tabs[this.selectedIndex], tabIndex: this.selectedIndex });
  }
}
